module.exports = __webpack_public_path__ + "static/service-concept-7fa6e49e67cfc68098bf02aa337f5b44.jpg";